// Workflow officiel du statut d'un contrat client
export const CONTRAT_STATUTS = [
  'Infos manquantes',
  'Contrat en brouillon',
  'Contrat à valider',
  'Contrat transmis',
  'Contrat à modifier',
  'Contrat renvoyé',
  'Signature en cours',
  'Contrat signé',
  'Dossier clôturé',
  'Dossier archivé',
  'Refusé',
  'Annulé',
  'Reporté',
  'Perdu / sans réponse',
] as const;

export type ContratStatut = (typeof CONTRAT_STATUTS)[number];

// Compat : map des anciennes valeurs courtes vers les nouvelles
const LEGACY_MAP: Record<string, ContratStatut> = {
  Brouillon: 'Contrat en brouillon',
  Transmis: 'Contrat transmis',
  Signé: 'Contrat signé',
  Refuse: 'Refusé',
  Annule: 'Annulé',
};

export function normalizeContratStatut(s?: string | null): ContratStatut {
  if (!s) return 'Contrat en brouillon';
  return (LEGACY_MAP[s] || (CONTRAT_STATUTS as readonly string[]).find((c) => c === s) || s) as ContratStatut;
}

export function contratStatutClass(s?: string | null): string {
  const n = normalizeContratStatut(s);
  switch (n) {
    case 'Infos manquantes':
      return 'bg-orange-500/20 text-orange-300 border-orange-500/40';
    case 'Contrat en brouillon':
      return 'bg-slate-700/40 text-slate-300 border-slate-600/40';
    case 'Contrat à valider':
      return 'bg-amber-500/20 text-amber-300 border-amber-500/40';
    case 'Contrat transmis':
    case 'Contrat renvoyé':
      return 'bg-sky-500/20 text-sky-300 border-sky-500/40';
    case 'Contrat à modifier':
      return 'bg-yellow-500/20 text-yellow-300 border-yellow-500/40';
    case 'Signature en cours':
      return 'bg-indigo-500/20 text-indigo-300 border-indigo-500/40';
    case 'Contrat signé':
      return 'bg-emerald-500/20 text-emerald-300 border-emerald-500/40';
    case 'Dossier clôturé':
      return 'bg-teal-500/20 text-teal-300 border-teal-500/40';
    case 'Dossier archivé':
      return 'bg-slate-800 text-slate-400 border-slate-700';
    case 'Refusé':
    case 'Perdu / sans réponse':
      return 'bg-rose-500/20 text-rose-300 border-rose-500/40';
    case 'Annulé':
      return 'bg-red-500/20 text-red-300 border-red-500/40';
    case 'Reporté':
      return 'bg-violet-500/20 text-violet-300 border-violet-500/40';
    default:
      return 'bg-slate-700/40 text-slate-300 border-slate-600/40';
  }
}

// Regroupements pour onglets
export const STATUTS_TRANSMIS_GROUP: ContratStatut[] = [
  'Infos manquantes',
  'Contrat en brouillon',
  'Contrat à valider',
  'Contrat transmis',
  'Contrat à modifier',
  'Contrat renvoyé',
  'Signature en cours',
];

export const STATUTS_SIGNES_GROUP: ContratStatut[] = [
  'Contrat signé',
  'Dossier clôturé',
  'Dossier archivé',
];

export const STATUTS_PERDUS_GROUP: ContratStatut[] = [
  'Refusé',
  'Annulé',
  'Reporté',
  'Perdu / sans réponse',
];
